export default __webpack_public_path__ + "static/psle-slay-screen-1-e216afbdeb9ec2e69d3cb9ad844b8606.png";